import { MessageCircle, Phone } from "lucide-react";

const WhatsAppButton = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-3">
      {/* Call Button */}
      <a
        href="tel:+919994849332"
        aria-label="Call +91 99948 49332"
        className="w-14 h-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg hover:scale-110 active:scale-95 transition-transform"
      >
        <Phone size={26} className="relative z-10" />
      </a>
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/919994849332"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 active:scale-95 transition-transform"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
        <MessageCircle size={28} fill="white" className="relative z-10" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
